import { lazy } from 'react'

import AppRouteInterface from 'src/types/AppRouteInterface'
import { Product, SubProduct } from 'src/utils/product'

const chatBotRoutes: ReadonlyArray<AppRouteInterface> = [
  {
    path: `/${Product.REPORT}/${SubProduct.ChatBot}/:id?`,
    component: lazy(
      () =>
        /* webpackMode: "lazy", webpackChunkName: "ai_chatbot" */
        import('src/components/ui/pages/common/ChatBotPage'),
    ),
  },
]

export default chatBotRoutes
